module.exports = [
 {
  "start": 41,
  "end": 3875,
  "text": "This tiny work in the floor Selbstlos im Lavabad (Selfless In The Bath Of Lava) "
 },
 {
  "start": 3917,
  "end": 6041,
  "text": "deals with the question of individual "
 },
 {
  "start": 6166,
  "end": 8375,
  "text": "and collective guilt symbolised "
 },
 {
  "start": 8458,
  "end": 10667,
  "text": "by the notion of hell and purgatory "
 },
 {
  "start": 11000,
  "end": 12208,
  "text": "It is dealing with the "
 },
 {
  "start": 12250,
  "end": 15750,
  "text": "Christian/Jewish/Muslim collective psychosis "
 },
 {
  "start": 16125,
  "end": 19250,
  "text": "whether we are already guilty as newborn, "
 },
 {
  "start": 19375,
  "end": 22041,
  "text": "and the misuse of these religious theories "
 },
 {
  "start": 22125,
  "end": 24625,
  "text": "to manipulate us and keep us small "
 },
 {
  "start": 24750,
  "end": 26417,
  "text": "and obeying that this life "
 },
 {
  "start": 26500,
  "end": 28625,
  "text": "is only a test for the afterlife"
 },
 {
  "start": 29208,
  "end": 31166,
  "text": "even if we consider ourselves "
 },
 {
  "start": 31250,
  "end": 33000,
  "text": "as enlightened and atheist "
 },
 {
  "start": 33166,
  "end": 34959,
  "text": "the ideas of guilt creep "
 },
 {
  "start": 35125,
  "end": 37583,
  "text": "in from our cultural subconciounsness"
 },
 {
  "start": 38291,
  "end": 40417,
  "text": "the giant mighty visitor "
 },
 {
  "start": 40500,
  "end": 42208,
  "text": "is asked for forgiveness "
 },
 {
  "start": 42291,
  "end": 45166,
  "text": "and a mildness toward oneself and the other"
 },
 {
  "start": 45500,
  "end": 46458,
  "text": "the work speaks also "
 },
 {
  "start": 46542,
  "end": 48708,
  "text": "about moral cleaning "
 },
 {
  "start": 48834,
  "end": 50166,
  "text": "and its overload"
 },
 {
  "start": 50625,
  "end": 52208,
  "text": "how can we empower each other "
 },
 {
  "start": 52291,
  "end": 53291,
  "text": "without becoming "
 },
 {
  "start": 53417,
  "end": 55208,
  "text": "reckless and selfish?"
 }
]


// WEBPACK FOOTER //
// ./src/Rist/content/tourWorks/room8/audio1/08_MCA Selfless in the Bath Of Lava.js